import { render } from "./SETpayment.vue?vue&type=template&id=aa7e668e&scoped=true"
const script = {}

import "./SETpayment.vue?vue&type=style&index=0&id=aa7e668e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa7e668e"]])

export default __exports__